import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "open-orders" };
const _hoisted_2 = { class: "section-title" };
const _hoisted_3 = {
    key: 0,
    class: "section-title__info"
};
const _hoisted_4 = {
    key: 1,
    class: "open-orders__view-switch"
};
import { onMounted, ref } from 'vue';
import moment from "moment";
import WeekCalendar from "@astina/paloma-common-ui/src/components/WeekCalendar.vue";
import PendingOrdersList from "../components/PendingOrdersList.vue";
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
import CurrentlyUnavailable from "../components/CurrentlyUnavailable.vue";
import deliveries from "../services/DeliveryRepository";
import config from "../services/PortalConfig";
export default /*@__PURE__*/ _defineComponent({
    __name: 'HomePendingOrders',
    setup(__props) {
        const date = ref(moment().startOf('week').toDate());
        const weeks = ref(2);
        const deliveryEvents = ref([]);
        const loading = ref(false);
        const error = ref(false);
        const currentView = ref(config.homePendingOrdersComponents == 'calendar' ? 'calendar' : 'list');
        onMounted(() => {
            loading.value = true;
            load(date.value);
        });
        function onCalendarChange(from) {
            load(from);
        }
        function load(date) {
            error.value = false;
            const targetDate = moment(date).format('yyyy-MM-DD');
            return deliveries
                .listExpectedDeliveries(targetDate, moment(date).add(weeks.value, 'weeks').format('yyyy-MM-DD'))
                .then(data => deliveryEvents.value = data.deliveries
                .map(delivery => {
                return {
                    date: moment(delivery.date).toDate(),
                    title: delivery.orderNumber || delivery.deliveryNumber || '?',
                    details: '',
                    route: {
                        name: delivery.type === 'delivery' ? 'deliveries_delivery' : 'orders_order',
                        params: delivery.type === 'delivery' ? { id: delivery.deliveryId } : { orderNumber: delivery.orderNumber },
                    },
                };
            }))
                .catch(() => error.value = true)
                .finally(() => loading.value = false);
        }
        function toggleView() {
            currentView.value = currentView.value === 'calendar' ? 'list' : 'calendar';
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h3", null, [
                        _createVNode(Icon, {
                            name: "orders",
                            "icon-style": "duotone"
                        }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('orders.overview')), 1)
                    ]),
                    _cache[0] || (_cache[0] = _createTextVNode()),
                    (deliveryEvents.value.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createVNode(_component_router_link, { to: { name: 'orders' } }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('orders.show')), 1)
                                ]),
                                _: 1
                            })
                        ]))
                        : _createCommentVNode("", true),
                    _cache[1] || (_cache[1] = _createTextVNode()),
                    (_unref(config).homePendingOrdersComponents === 'both')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createVNode(Icon, {
                                name: currentView.value === 'calendar' ? 'list' : 'calendar',
                                "icon-style": "duotone",
                                class: "open-orders__view-switch-icon",
                                onClick: toggleView
                            }, null, 8, ["name"])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _cache[2] || (_cache[2] = _createTextVNode()),
                _createVNode(Spinner, { loading: loading.value }, null, 8, ["loading"]),
                _cache[3] || (_cache[3] = _createTextVNode()),
                (!loading.value && !error.value && currentView.value === 'calendar')
                    ? (_openBlock(), _createBlock(WeekCalendar, {
                        key: 0,
                        events: deliveryEvents.value,
                        date: date.value,
                        "min-date": date.value,
                        "number-of-weeks": weeks.value,
                        "no-events-message": "orders.none_pending",
                        onChange: onCalendarChange
                    }, null, 8, ["events", "date", "min-date", "number-of-weeks"]))
                    : _createCommentVNode("", true),
                _cache[4] || (_cache[4] = _createTextVNode()),
                (!loading.value && !error.value && currentView.value === 'list')
                    ? (_openBlock(), _createBlock(PendingOrdersList, {
                        key: 1,
                        events: deliveryEvents.value,
                        date: date.value,
                        "min-date": date.value,
                        "number-of-weeks": weeks.value,
                        "no-events-message": "orders.none_pending",
                        onChange: onCalendarChange
                    }, null, 8, ["events", "date", "min-date", "number-of-weeks"]))
                    : _createCommentVNode("", true),
                _cache[5] || (_cache[5] = _createTextVNode()),
                (error.value)
                    ? (_openBlock(), _createBlock(CurrentlyUnavailable, { key: 2 }))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
